import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { ManagedCardService } from "./managecards.service";
import { LiveCard, CostCentre, CardDrawing, CardDetail, LiveCardModel, CostCentreModel, LiveCardsDataTablesResponse } from "./managecards";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";
import { DatePipe } from "@angular/common";
import { AcceptedResponse, DrawingsDataTablesResponse } from "../cardtransaction/cardtransaction";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ResponseContentType, Http } from "@angular/http";
declare var $: any;

@Component({
  templateUrl: "./managedcards.livecards.component.html"
})
export class LiveCardsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtOptionsCardsTable: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Manage Cards';
  public managedCardsName: string = 'livecards';
  public liveCardsList: LiveCard[];
  public liveCard: LiveCard;
  public amendCostCenterCard: string = '';
  public costCentresList: CostCentre[] = [];
  public cardDrawingList: CardDrawing[];
  public costCentre: CostCentre = new CostCentre();
  public viewCard: CardDetail = new CardDetail();
  public accessAccounts: IAccount[];
  public addedOrDeletedCostCentre: boolean = false;
  public referenceNumber: string = "";
  public showLiveCards: boolean = false;
  liveCardTypeValue: any = undefined;
  dt: any;
  public detailRows: string[] = [];


  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public managedCardService: ManagedCardService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private httpcall: Http
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    $('#livecardsdatatable').DataTable().destroy();
    this.dtOption();
    this.liveCardsOnInit();
    //console.log(this.loaderService.status);
    //this.afterloaddata();
  }
  ngAfterViewInit(): void {
    const selfMe = this;
    $('#modal-amendcost').on('hidden.bs.modal', function () {
      selfMe.costCentresList = [];
      if (selfMe.addedOrDeletedCostCentre) {
        selfMe.addedOrDeletedCostCentre = false;
        //selfMe.liveCardsOnInit();
      }

    });
    $('#modal-drawings').on('hidden.bs.modal', function () {
      $('#drawingsdatatable').DataTable().destroy();
      //$('#drawingsdatatable').empty();
      selfMe.cardDrawingList = [];
    });

    $.extend($.fn.dataTableExt.oSort, {
      "non-empty-string-asc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
      },

      "non-empty-string-desc": function (str1, str2) {
        if (str1 == null || str1 == "")
          return 1;
        if (str2 == null || str2 == "")
          return -1;
        return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
      }
    });
  }

  liveCardsOnInit(): void {
    this.liveCardsList = null;
    this.loaderService.display(true);
    //this.loadLiveCardsList();
    this.loadLiveCardsListNew();

  }
  //afterloaddata() {    
  //  const self = this;

  //  var table = $('#livecardsdatatable').DataTable();
  //  // Array to track the ids of the details displayed rows
  //  var detailRows = [];

  //  //$('#livecardsdatatable').delegate('click', 'tbody tr .view-details', function () {
  //  // 
  //  //  var tr = $(this).closest('tr');
  //  //  var row = table.row(tr);
  //  //  var id = $(this).closest('tr').find('td').eq(0).text();
  //  //  var idx = $.inArray(id, detailRows);      
  //  //  if (row.child.isShown()) {
  //  //    tr.removeClass('shown');
  //  //    row.child.hide();
  //  //    // Remove from the 'open' array
  //  //    detailRows.splice(idx, 1);
  //  //  }
  //  //  else {        
  //  //    self.managedCardService.getCardById(id)
  //  //      .subscribe(
  //  //      (cardDetail: CardDetail) => {
  //  //        this.viewCard = cardDetail;            

  //  //        row.child(format(this.viewCard)).show();
  //  //        tr.addClass('shown');
  //  //        // Add to the 'open' array
  //  //        if (idx === -1) {
  //  //          detailRows.push(id);
  //  //        }
  //  //      },
  //  //      (error: any) => {
  //  //        this.managedCardService.showError("Card detail retrieval problem", <any>error)
  //  //      }
  //  //      );
  //  //  }
  //  //});

  //  // On each draw, loop over the `detailRows` array and show any child rows
  //  table.on('draw', function () {      
  //    $.each(detailRows, function (i, id) {        
  //      $('#' + id + ' td .view-details').trigger('click');
  //    });
  //  });

  //  // Apply the search




  //  $('.dataTables_filter input', table.table().container())
  //    .off('.DT')
  //    .on('keyup.DT cut.DT paste.DT input.DT search.DT', function (e) {
  //      if (this.value.length >= 1) {
  //        // Call the API search function
  //        table.search(this.value.replace(/\u200C/g, '')).draw();
  //      }

  //      // Ensure we clear the search if they backspace far enough
  //      if (this.value === "") {
  //        table.search("").draw();
  //      }
  //   });


  //  function format(d:CardDetail) {
  //    var carddetailinfo = "Card Number: " + d.cardNumber + "<br>";
  //    carddetailinfo = carddetailinfo + "Account Number: " + d.accountNumber + "<br>";      
  //    carddetailinfo = carddetailinfo + "Purchase Option: " + d.purchaseCode + "<br>";      
  //    carddetailinfo = carddetailinfo + "Issued: " + self.formatDateDDMMYY(d.issueDate) + "<br>";
  //    carddetailinfo = carddetailinfo + "Expires: " + self.formatDateDDMMYY(d.expiryDate) + "<br>";
  //    carddetailinfo = carddetailinfo + "Last Used: " + self.formatDateDDMMYY(d.lastUsedDate) + "<br>";
  //    //carddetailinfo = carddetailinfo + "Account Manager: " + d.accountManagerName + "<br>";
  //    carddetailinfo = carddetailinfo + "Name on Card: " + d.nameOnCard + "<br>";
  //    carddetailinfo = carddetailinfo + "Registration: " + d.registration + "<br>";
  //    return carddetailinfo;
  //  }
  //}
  loadLiveCardsList() {
    var model: LiveCardModel = new LiveCardModel();
    model.AccountNumbers = [];
    model.Token = this.authService.getToken().access_token;
    model.EndPointURL = ApiEndPoints.LiveCardsEndPoint;
    model.AccountEndPointURL = ApiEndPoints.AccountAccessEndPoint;
    model.UserId = this.authService.getToken().userId;

    model.CostCentreModel = new CostCentreModel();
    model.CostCentreModel.Token = this.authService.getToken().access_token;
    model.CostCentreModel.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint;;


    this.accessAccounts.forEach(item => {
      model.AccountNumbers.push(item.name);
    });
    this.managedCardService.getLiveCards(model)
      .subscribe(
        (livecards: LiveCard[]) => {
          this.liveCardsList = livecards;
          setTimeout(() => {

            this.loaderService.display(false);
          }, 100);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.managedCardService.showError("LiveCards retrieval problem", <any>error);
        }
      );
  }
  openCostCentre(liveCard: LiveCard) {

    this.managedCardService.msgs = [];
    this.liveCard = liveCard;
    this.amendCostCenterCard = this.liveCard.cardNumber;
    this.resetCostCentreTabel();
    this.readCostCentres(this.liveCard.id);
  }
  resetCostCentreTabel() {
    this.costCentresList = [];
  }
  readCostCentres(id: string) {
    this.loaderService.display(true);
    this.costCentre = new CostCentre();
    this.managedCardService.getCostCentreByCardId(id)
      .subscribe(
        (costCentres: CostCentre[]) => {
          this.costCentresList = costCentres;
          //console.log(this.costCentresList)
          setTimeout(() => {
            this.afterCostCentresLoadData();
            this.loaderService.display(false);
          }, 100);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.managedCardService.showError("Cost Centre retrieval problem", <any>error);
        }
      );
    $('#modal-amendcost').modal('show');
  }
  afterCostCentresLoadData() {
    if (!$.fn.DataTable.isDataTable('#amendcostdatatable')) {
      $('#amendcostdatatable').DataTable({
        //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
        dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        responsive: true,
        info: false,
        iDisplayLength: 10,
        ordering: false,
        fixedColumns: true,
        pageLength: 10,
        pagingType: "full_numbers",
        paging: true
      });
    }
  }
  addCostCentre(costCentre: CostCentre) {
    this.loaderService.display(true);
    this.managedCardService.msgs = [];
    var dDate = costCentre.effectiveDateDate;
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    let accountNumbers = [];
    this.accessAccounts.forEach(item => {
      accountNumbers.push(item.name);
    });
  
    if (dDate != null) {
      costCentre.effectiveDate = dDate.toString();
      if (typeof costCentre.effectiveDate != 'undefined' && costCentre.effectiveDate) {
        costCentre.effectiveDate = this.formatDate(costCentre.effectiveDate);
      }
      else {
        costCentre.effectiveDate = this.formatedCurrentDate();
      }
      var dateEffectiveAlreadyExist: boolean = false;
      this.costCentresList.forEach(ele => {
        var formatedDate = this.datePipe.transform(ele.effectiveDate, 'yyyy-MM-dd');
        if (formatedDate === costCentre.effectiveDate) {
          this.managedCardService.showError("Create cost centre problem", <any>"Date effective is already exists", true);
          dateEffectiveAlreadyExist = true;
        }
      });
      if (!dateEffectiveAlreadyExist) {
        //this.managedCardService.createCostCentre(costCentre, this.liveCard.id)
        this.managedCardService.createCostCentreNew(costCentre, this.liveCard.id, userData.sub, accountNumbers)
          .subscribe(
            () => {
              this.addedOrDeletedCostCentre = true;
              this.resetCostCentreTabel();
              this.readCostCentres(this.liveCard.id);
              this.loaderService.display(false);
            },
            (error: any) => {
              this.loaderService.display(false);
              this.managedCardService.showError("Create cost centre problem", <any>error, true);
            }
          );
      }
      else {
        costCentre.effectiveDate = new Date(costCentre.effectiveDate).toString();
        this.loaderService.display(false);
      }
    }
    else {
      this.managedCardService.showError("Create cost centre problem", <any>"Date effective is required.", true);
      this.loaderService.display(false);
    }
  }
  deleteCostCentre(costCentre: CostCentre) {
    this.loaderService.display(true);
    this.managedCardService.msgs = [];
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    let accountNumbers = [];
    this.accessAccounts.forEach(item => {
      accountNumbers.push(item.name);
    });
    //this.managedCardService.deleteCostCentre(costCentre, this.liveCard.id)
    this.managedCardService.deleteCostCentreNew(costCentre, this.liveCard.id ,userData.sub, accountNumbers)
      .subscribe(
        () => {
          this.addedOrDeletedCostCentre = true;
          this.resetCostCentreTabel();
          this.readCostCentres(this.liveCard.id);
          //$('#modal-amendcost').modal('hide');
        },
        (error: any) => {
          this.managedCardService.showError("Delete cost centre problem", <any>error, true);
        }
      );
  }
  //date format
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  formatedCurrentDate() {
    var d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  formatDateDDMMYY(date) {
    //debugger
    if (date == "0001-01-01T00:00:00") {
      return "null";
      }
      if (date == "0001-01-01T00:00:00Z") {
          return "null";
      }
     
    var d1 = new Date(Date.parse(date)),
      month = '' + ((new Date(d1).getMonth() + 1)),
      day = '' + new Date(d1).getDate(),
      year = new Date(d1).getFullYear(),
      hh = new Date(d1).getUTCHours().toString(),
      mm = new Date(d1).getUTCMinutes().toString(),
      ss = new Date(d1).getUTCSeconds().toString();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    if (hh.length < 2) hh = '0' + hh;
    if (mm.length < 2) mm = '0' + mm;
    if (ss.length < 2) ss = '0' + ss;

    //var d = new Date(date),
    //  month = '' + (d.getMonth() + 1),
    //  day = '' + d.getDate(),
    //  year = d.getFullYear(),
    //  hh = d.getHours().toString(),
    //  mm = d.getMinutes().toString(),
    //  ss = d.getSeconds().toString();
    //if (month.length < 2) month = '0' + month;
    //if (day.length < 2) day = '0' + day;

    //if (hh.length < 2) hh = '0' + hh;
    //if (mm.length < 2) mm = '0' + mm;
    //if (ss.length < 2) ss = '0' + ss;
    return [day, month, year].join('/') + " " + [hh, mm, ss].join(':');
  }

  openDrawings(liveCard: LiveCard) {
    this.loaderService.display(true);
    this.liveCard = liveCard;
    this.resetDrawingTabel();
    this.readDrawings(this.liveCard.id);
  }
  resetDrawingTabel() {
    this.cardDrawingList = [];
  }
  readDrawings(id: string) {
    this.costCentre = new CostCentre();
    this.managedCardService.getDrawingsByCardId(id)
      .subscribe(
        (cardDrawings: CardDrawing[]) => {
          this.cardDrawingList = cardDrawings;
          setTimeout(() => {
            this.afterDrawingsLoadData();
            this.loaderService.display(false);
          }, 1000);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.managedCardService.showError("Cost Centre retrieval problem", <any>error);
        }
      );
    $('#modal-drawings').modal('show');
  }
  afterDrawingsLoadData() {
    if (!$.fn.DataTable.isDataTable('#drawingsdatatable')) {
      $('#drawingsdatatable').DataTable({
        //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
        dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        responsive: true,
        info: false,
        iDisplayLength: 20,
        ordering: false,
        fixedColumns: true,

      });
    }
    this.loaderService.display(false);
  }



  checkLiveCardStatus(acceptedResponse: AcceptedResponse) {
    if (acceptedResponse.statuscode == "202") {
      var athis = this;
      setTimeout(function () {
        athis.managedCardService.checkLiveCardStatus(acceptedResponse.location)
          .subscribe(
            (response: AcceptedResponse) => {
              athis.loaderService.display(true);
              //athis.liveCardsOnInit();
              $('#modal-amendcost').modal('hide');
              athis.checkLiveCardStatus(response);

            },
            (error: any) => {
              athis.loaderService.display(false);
              athis.managedCardService.showError("Drawing Accounts retrieval problem", <any>error);
            }
          );
      }, acceptedResponse.retryafter);
    }
    else if (acceptedResponse.statuscode == "200") {
      if (acceptedResponse.error != null) {
        //console.log("524");
        this.loaderService.display(false);
        this.managedCardService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
      }
      else {
        if (acceptedResponse.referenceNumber != null) {
          this.showLiveCards = true;

          this.referenceNumber = acceptedResponse.referenceNumber;
          //this.dtOptions();
        }
        else {
          //console.log("536");
          this.loaderService.display(false);
          this.managedCardService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
        }
      }
    }
    else if (acceptedResponse.statuscode == "400") {
      this.loaderService.display(false);
      this.managedCardService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
    }
  }

  loadLiveCardsListNew() {
    var model: LiveCardModel = new LiveCardModel();
    model.AccountNumbers = [];
    model.Token = this.authService.getToken().access_token;
     //model.EndPointURL = ApiEndPoints.LiveCardsEndPoint;

    //model.AccountEndPointURL = ApiEndPoints.AccountAccessEndPoint;
    let user = this.authService.getUser();
    //overwritten on 08-01-2020 as userId was returning null
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != null) {
      model.UserId = userData.sub;
    }
    //model.UserId = this.authService.getToken().userId;

    model.CostCentreModel = new CostCentreModel();
    model.CostCentreModel.Token = this.authService.getToken().access_token;
    model.CostCentreModel.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint;;


    this.accessAccounts.forEach(item => {
      model.AccountNumbers.push(item.name);
    });
    this.managedCardService.getLiveCardsNew(model)
      .subscribe(
        (acceptedResponse: AcceptedResponse) => {
          this.checkLiveCardStatus(acceptedResponse);
        },
        (error: any) => {
          //console.log("569");
          this.loaderService.display(false);
          this.managedCardService.showError("Drawing Accounts retrieval problem", <any>error);
        }
      );
  }

  dtOption() {

    var athis = this;

    this.dtOptions = {

      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      info: false,
      iDisplayLength: 15,
      order: [],

      responsive: true,
      autoWidth: false,
      // fixedColumns: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [
            {
              text: '<i class="fa fa-file-excel-o"> Excel</i>',
              titleAttr: 'Excel',
              action: function (e, dt, node, config) {
                athis.downloadLiveCards('Excel');
              }
            },
            {
              text: '<i class="fa fa-file-csv-o"> CSV</i>',
              titleAttr: 'CSV',
              action: function (e, dt, node, config) {
                athis.downloadLiveCards('Csv');
              }
            },
            {
              text: '<i class="fa fa-file-pdf-o"> PDF</i>',
              titleAttr: 'PDF',
              action: function (e, dt, node, config) {
                athis.downloadLiveCards('Pdf');
              }
            }
          ]
        }
      ],
      //pagingType: 'full_numbers',
      pageLength: 15,
      serverSide: true,
      processing: true,

      ajax: (dataTablesParameters: any, callback) => {

        this.loaderService.display(true);
        this.http
          .post<LiveCardsDataTablesResponse>(
            (ApiEndPoints.BaseURL + ApiEndPoints.GetLiveCardsData + "?referenceNumber=" + this.referenceNumber),
            dataTablesParameters, {}
          ).subscribe(resp => {
            if (resp.error == null) {
              if (resp.data.length > 0) {
                // console.log(resp.data);
                this.liveCardsList = resp.data;

                this.loaderService.display(false);
              }
              else {
                //console.log(resp);
                this.liveCardsList = null;
                //console.log("672");
                this.loaderService.display(false);
              }
            }
            else {
              //console.log("677");
              this.loaderService.display(false);
              if (resp.error == "NoReferenceFound") {
                // this.cardTransactionFrm.ngSubmit.emit();
              }
            }
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: resp.data
              //data:[]
            });
          });
      },

      deferRender: true,
      columns: [{ data: 'id', visible: false },
      { data: 'cardNumber' },
      { data: 'accountNumber' },
      { data: 'drawingPointNumber' },
      { data: 'driverName' },
      { data: 'vrn' },
      { data: 'purchaseCode', visible: false },
      { data: 'pin', visible: false },
      { data: 'issueDate', visible: false },
      { data: 'expiryDate', visible: false },
      { data: 'lastUsedDate', visible: false },
      { data: 'CostCentre', visible: false },
      { data: 'DriverDescription', visible: false },
      { data: 'DateEffective', visible: false },
      // {dat:'',
      // render: (data, type, full) => `<button (click)="testClick()">ClickMe</button>`},
      {
        data: 'amend cost centre',
        orderable: false,
        searchable: false,
        render: function (data, type, row, meta) { // render event defines the markup of the cell text 

          var a = '<span class="link AMC" data-toggle="modal">amend cost centre</span>'; // row object contains the row data

          return a;
        }
      },
      {
        data: 'View',
        orderable: false,
        searchable: false,

        render: function (data, type, row, meta) { // render event defines the markup of the cell text
          const contact = JSON.stringify(row).split('"').join('\'');
          var a = '<span data-details="' + contact + '" class="link view-details VD1">View</span>'; // row object contains the row data
          return a;
        }
      },
      {
        data: 'View',
        orderable: false,
        searchable: false,
        render: function (data, type, row, meta) { // render event defines the markup of the cell text
          const contact = JSON.stringify(row).split('"').join('\'');
          var a = '<span data-drawings="' + contact + '" class="link view-drawings VD2" data-toggle="modal" >View</span>'; // row object contains the row data
          return a;
        }
      },

      ],
      columnDefs: [{ targets: [0], visible: false, searchable: false }, { searchable: false, orderable: false, targets: [11, 12, 13] }, { "type": "non-empty-string", targets: [4, 5] }],
      initComplete: function () {
        var api = this.api();
        api.columns().every(function () {
          var that = this;
          $('input', this.footer()).on('keyup change', function () {
            ;
            if (that.search() !== this.value) {
              that.search(this.value).draw();
            }
          });

        });

      },
      drawCallback: function () {
        var api = this.api();

        //this.detailRows.clear();
        // this.detailRows.splice(0,this.detailRows.length)
        // 
        $('ul.pagination li a', this.api().table().container()).on('click', () => {
          athis.detailRows = [];
          $(".detailTable").each(function () {
            this.setAttribute("style", "display:none;")
          })
        });
      },
      rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)

        $('td', nRow).unbind('click');
        $('td .AMC', nRow).bind('click', function () {
          //console.log(JSON.stringify(aData));
          //console.log(nRow);     
          let liveCard = aData;

          athis.openCostCentre(liveCard);


        });

        //$('td .VD1', nRow).bind('click', function() 
        //{               
        // let liveCard=aData;  
        // let event=this;
        // console.log(event);
        //   
        // athis.getDetail(liveCard,event);         

        //});
        $('table').unbind('click');
        $("table").on('click', '.VD1', function () {
          let liveCard = aData;
          let event = this;
          liveCard = JSON.parse($(this).data('details').split('\'').join('"'));
          athis.getDetail(liveCard, event);
        });


        //$('td .VD2', nRow).bind('click', function () {
        //  let liveCard = aData;

        //  athis.openDrawings(liveCard);

        //});

        $("table").on('click', '.VD2', function () {
          let liveCard = aData;
          let event = this;
          liveCard = JSON.parse($(this).data('drawings').split('\'').join('"'));
          athis.openDrawings(liveCard);
        });
        return nRow;
      }

    }

    var table = $('#livecardsdatatable').DataTable(this.dtOptions).ajax.reload();

    this.dt = table;

  }

  testClick() {
    alert('Hi');
  }
  downloadLiveCards(type: string) {
    this.loaderService.display(true);
    //this.getCardTransDocument(this.referenceNumber, type);
    this.getLiveCardsDocumentNew(this.referenceNumber, type);
  }


  getLiveCardsDocumentNew(refNumber: string, type: string) {
    var sort = "";
    if (this.liveCardTypeValue == undefined || this.liveCardTypeValue == 1) {
      sort = "drawn";
    }
    else {
      sort = "invoiced";
    }
    this.managedCardService.prePareLiveCardDocument(refNumber, type, sort)
      .subscribe(
        (acceptedResponse: AcceptedResponse) => {
          if (acceptedResponse.error == "NoReferenceFound") {
            //this.cardTransactionFrm.ngSubmit.emit();
          }
          else {
            this.checkPrepareLiveCardStatus(acceptedResponse, type);
          }
        },
        (error: any) => {
          this.loaderService.display(false);
          this.managedCardService.showError("Card transaction prepare problem", <any>error);
        }
      );
  }


  checkPrepareLiveCardStatus(acceptedResponse: AcceptedResponse, type: string) {
    if (acceptedResponse.statuscode == "202") {
      var athis = this;
      setTimeout(function () {
        athis.managedCardService.checkLiveCardStatus(acceptedResponse.location)
          .subscribe(
            (response: AcceptedResponse) => {
              athis.checkPrepareLiveCardStatus(response, type);
            },
            (error: any) => {
              athis.loaderService.display(false);
              athis.managedCardService.showError("Card transaction prepare problem", <any>error);
            }
          );
      }, acceptedResponse.retryafter);
    }
    else if (acceptedResponse.statuscode == "200") {
      if (acceptedResponse.error != null) {
        this.loaderService.display(false);
        this.managedCardService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
      }
      else {
        if (acceptedResponse.referenceNumber != null) {
          this.downloadCardTransDocument(acceptedResponse.referenceNumber, type);
        }
        else {
          this.loaderService.display(false);
          this.managedCardService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
        }
      }
    }
    else if (acceptedResponse.statuscode == "400") {
      this.loaderService.display(false);
      this.managedCardService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
    }
  }



  downloadCardTransDocument(refNumber: string, type: string) {
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadNewLiveCardEndPoint;
    callURL = callURL.replace("{id}", refNumber).replace("{type}", type);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/x-www-form-urlencoded;'
    //});
    return this.httpcall
      .get(callURL, {
        responseType: ResponseContentType.Blob
      })
      .map(res => {
        const contentDisposition = res.headers.get('content-disposition') || '';
        const matches = /filename=([^;]+)/ig.exec(contentDisposition);
        const fileName = (matches[1] || 'untitled').trim();
        return {
          filename: fileName,
          data: res.blob()
        };
      })
      .subscribe(res => {

        if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
          this.loaderService.display(false);
        }
        else {
          var url = window.URL.createObjectURL(res.data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = res.filename;
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
            this.loaderService.display(false);
          }, 1000);
        }
      }, error => {
        this.loaderService.display(false);
        //alert('download error:' + JSON.stringify(error));
        //this.cardTransactionFrm.ngSubmit.emit();
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
  }

  getDetail(livecard, event) {
    const self = this;
    var table = this.dt;
    this.loaderService.display(true);
    // Array to track the ids of the details displayed rows

    var tr = $(event.parentElement).closest('tr');
    var row = table.row(tr);
    var idx = $.inArray(livecard.id, this.detailRows);
    if (idx != -1) {
      tr.removeClass('shown');
      tr.next().hide();
      // Remove from the 'open' array
      this.detailRows.splice(idx, 1);
      this.loaderService.display(false);
    }
    else {
      //self.managedCardService.getCardById(id)
      //  .subscribe(
      //    (cardDetail: CardDetail) => {
      //      this.viewCard = cardDetail;
      //      tr.addClass('shown');           
      //      tr.after(self.format1(cardDetail));
      //      if (idx === -1) {
      //        this.detailRows.push(id);
      //      }
      //      this.loaderService.display(false);
      //    },
      //    (error: any) => {
      //      this.managedCardService.showError("Card detail retrieval problem", <any>error)
      //      this.loaderService.display(false);
      //    }
      //  );
      tr.addClass('shown');
      tr.after(self.format1(livecard));
      if (idx === -1) {
        this.detailRows.push(livecard.id);
      }

      this.loaderService.display(false);
    }
  }

  format(d: CardDetail) {
    const self = this;
    console.log(d);
    var carddetailinfo = "Card Number: " + d.cardNumber + "<br>";
    carddetailinfo = carddetailinfo + "Account Number: " + d.accountNumber + "<br>";
    carddetailinfo = carddetailinfo + "Purchase Option: " + d.purchaseCode + "<br>";
    carddetailinfo = carddetailinfo + "Issued: " + d.issueDate == null ? "" : self.formatDateDDMMYY(d.issueDate) + "<br>";
    carddetailinfo = carddetailinfo + "Expires: " + d.expiryDate == null ? "" : self.formatDateDDMMYY(d.expiryDate) + "<br>";
    carddetailinfo = carddetailinfo + "Last Used: " + d.lastUsedDate == null ? "" : self.formatDateDDMMYY(d.lastUsedDate) + "<br>";
    //carddetailinfo = carddetailinfo + "Account Manager: " + d.accountManagerName + "<br>";
    carddetailinfo = carddetailinfo + "Name on Card: " + d.nameOnCard + "<br>";
    carddetailinfo = carddetailinfo + "Registration: " + d.registration + "<br>";
    return carddetailinfo;
  }

  format1(d) {
    const self = this;
    //debugger
    return '<table class="detailTable" cellpadding="5" cellspacing="0" border="0" style="padding:20px 20px 20px 50px;display:block;">' +
      '<tr>' +
      '<td>Card Number: </td>' +
      '<td>' + d.cardNumber + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Account Number: </td>' +
      '<td>' + d.accountNumber + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Purchase Option: </td>' +
      '<td>' + d.purchaseCode + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Issued: </td>' +
      '<td>' + self.formatDateDDMMYY(d.issueDate) + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Expires: </td>' +
      '<td>' + self.formatDateDDMMYY(d.expiryDate) + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Last Used: </td>' +
      '<td>' + self.formatDateDDMMYY(d.lastUsedDate) + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Name on Card: </td>' +
      '<td>' + d.driverName + '</td>' +
      '</tr>' +
      '<tr>' +
      '<td>Registration: </td>' +
      '<td>' + d.vrn + '</td>' +
      '</tr>' +
      '</table>';
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }
    if (userData != undefined) {
      let UserId = userData.sub;
      this.managedCardService.ClearStopCardsMemory(UserId, "livecards")
        .subscribe(
          (drawingAccounts: null) => {

          },
          (error: any) => {

          }
        );
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/managecards/managedcards.livecards.component.ts